import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import Logo from '../../components/Logo';
import Btn from '../../components/Btn';
import './navbar.css';
import '../../grid.css';
import SignOut from '../Inputs/SignOut';
import Button from '../../components/Button';

class NavBar extends Component {
    static propTypes = {
        firstName: PropTypes.string.isRequired,
        authToken: PropTypes.string.isRequired,
        clientId: PropTypes.number.isRequired,
        setSignOutIsVisible: PropTypes.func.isRequired,
        isSignOutVisible: PropTypes.bool.isRequired,
        eraseCustomerContact: PropTypes.func.isRequired,
        eraseCustomer: PropTypes.func.isRequired,
        setToggleView: PropTypes.func.isRequired,
    };

    toggleProposalView() {
        const { setToggleView } = this.props;
        setToggleView(true);
    }

    handleSignOut() {
        const {
            setSignOutIsVisible,
            isSignOutVisible,
            eraseCustomer,
            eraseCustomerContact,
        } = this.props;
        setSignOutIsVisible(!isSignOutVisible);
        eraseCustomer(null);
        eraseCustomerContact(null);
    }

    render() {
        const {
            authToken,
            clientId,
            firstName,
        } = this.props;

        return (
            <div className="navContainer">
                <Logo />
                <ul className="row nav">
                    <li className="li">
                        <Button
                            fullWidth
                            size="large"
                            color="secondary"
                            variant="contained"
                            onClick={e => this.toggleProposalView(e)}
                        >
                            Home
                        </Button>
                    </li>
                    {authToken ?
                        <li className="li">
                            <Btn className="navBtn" label="Customers" to="/customers" />
                        </li>
                        : null }
                    {authToken && firstName && (
                        <li className="li">
                            <Btn className="navBtn" label="Projects" to={`/customer/${clientId}`} />
                        </li>
                    )}
                    {authToken && (
                        <li className="li">
                            <Btn className="navBtn" label="Add User" to="/signup" />
                        </li>
                    )}
                    {authToken && (
                        <li className="li logOut">
                            <Btn className="navBtn" label="Log Out" onClick={(e, value) => this.handleSignOut(value)} />
                        </li>
                    )}
                    {authToken && <SignOut />}
                </ul>
            </div>
        );
    }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/containers/NavBar/NavBar.js